<template>
    <div>
        <v-dialog persistent v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                <span class=" black--text">Assign {{assessor.name}} To Community  </span>
                </v-card-title>

                <v-card-text>
                <v-container>
                    <v-autocomplete
                        v-model="communityCode"
                        :items="communities"
                        dense
                        label="Enter Community Code"
                        solo
                        item-text="community"
                        item-value="community_code"
                    >
                    
                    </v-autocomplete>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#62AE32" text @click="dialog=false">CANCEL</v-btn>
                            <v-btn color="#62AE32" :loading="loading" text @click="assign()">Assign</v-btn>
                        </v-card-actions>     
                </v-container>
                </v-card-text>

                
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialog2" max-width="500px">
            <v-card>
                <v-card-title>
                <span class=" black--text">Remove {{assessor.name}} From Community  </span>
                </v-card-title>

                <v-card-text>
                <v-container>
                    <v-autocomplete
                        v-model="communityCode"
                        :items="Community"
                        dense
                        label="Enter Community Code"
                        solo
                        item-text="community"
                        item-value="community_code"
                    >
                    
                    </v-autocomplete>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#62AE32" text @click="dialog2=false">CANCEL</v-btn>
                            <v-btn color="#62AE32" :loading="loading" text @click="remove()">Remove</v-btn>
                        </v-card-actions>     
                </v-container>
                </v-card-text>

                
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :timeout="4000" top :color="snackcolor">
            <span>{{text}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-container>
            <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
                <v-toolbar flat color="#F0FFEA" height="50" >
                    <v-toolbar-title style="color:#62AE32" class="headline">View Loss Assessor</v-toolbar-title>
                </v-toolbar>
                <v-row justify="center" class="mt-n3">
                    <v-avatar size="120" color="#62AE32">
                        <!-- <v-img class="" src="/Ellipse.png" alt="/account.png" lazy-src="/account.png"></v-img> -->
                        <span class="headline white--text">{{initials}}</span>
                    </v-avatar>
                    <v-tabs class="mt-n2" color="black" background-color="transparent">
                        <v-tabs-slider color="#B45C5C"></v-tabs-slider>
                        <v-tab >
                            Profile
                        </v-tab>
                        <v-tab>
                            Assigned Communities
                        </v-tab>
                        <v-tab-item style="background-color:#F0FFEA;">
                            <v-card  class="mx-auto"  max-width="500" color="#F0FFEA" flat> 
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6" class="mt-2">
                                    <span style="font-size:13px; color:#615D5D">Name</span>
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            label=""
                                            readonly
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.name"
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6" class="mt-2">
                                        <span style="font-size:13px; color:#615D5D">Username</span>
                                        
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.username"
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6">
                                        <span style="font-size:13px; color:#615D5D">Email</span>
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.email"
                                            style="font-size:14px"
                                            class="black-text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6" class="mt-2">
                                        <span style="font-size:13px; color:#615D5D">Phone Number</span>
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.phonenumber"
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mb-n4">
                                    <v-col class="mt-2" cols="12" md="4" sm="6">
                                        <span style="font-size:13px; color:#615D5D">Account Name</span>
                                        
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.account_name"
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row >
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6" class="mt-2">
                                        <span style="font-size:13px; color:#615D5D">Account Number</span>                  
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.account_number"
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6" class="mt-2">
                                        <span style="font-size:13px; color:#615D5D">Bank Name</span>                  
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-text-field
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            dense
                                            v-model="assessor.bankname"
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mb-n4">
                                    <v-col cols="12" md="4" sm="6" class="mt-2">
                                        <span style="font-size:13px; color:#615D5D">Address</span>                  
                                    </v-col>
                                    <v-col cols="12" md="8" sm="6">
                                        <v-textarea
                                            readonly
                                            label=""
                                            solo
                                            flat
                                            v-model="assessor.address"
                                            auto-grow="true" 
                                            style="font-size:14px"
                                            class="black--text"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card>
                                <template>
                                <v-data-table
                                    :headers="headers"
                                    :items="Community"
                                    :class="elevation-1"
                                    class="px-5"
                                    :items-per-page="5"
                                    :search="search"
                                    no-data-text="Loss Assessor Has not Been Attached To Any Community"
                                    >
                                    <template  v-slot:top>
                                        <v-toolbar flat color="white">
                                            <v-text-field
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                color="#08911B"
                                                style="width:20%"
                                            ></v-text-field>
                                            <v-spacer></v-spacer>
                                            <v-menu bottom left>
                                                <template v-slot:activator="{ on }">
                                                <v-btn
                                                    dark
                                                    icon
                                                    v-on="on"
                                                >
                                                    <v-icon color="#08911B">mdi-dots-vertical</v-icon>
                                                </v-btn>
                                                </template>

                                                <v-list>
                                                <v-list-item>
                                                    <v-tooltip top color="#62AE32">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn icon v-on="on" @click="dialog=true">
                                                            <v-icon color="#08911B">mdi-plus-circle-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span class="white--text">ASSIGN {{assessor.name}} TO A COMMUNITY </span>
                                                    </v-tooltip>
                                                    
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-tooltip bottom color="#62AE32">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn icon v-on="on" @click="dialog2=true">
                                                            <v-icon color="#08911B">mdi-minus-circle-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span class="white--text">REMOVE {{assessor.name}} FROM A COMMUNITY</span>
                                                    </v-tooltip>
                                                </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            
                                        </v-toolbar>
                                    </template>
                                    <template v-slot:item.action="{ item }"> 
                                        <v-icon
                                        style="color:#B45C5C; cursor: pointer;"
                                        @click="getName(item.community_id)"
                                        >
                                        mdi-chevron-right
                                        </v-icon>   
                                    </template>

                                </v-data-table>
                                </template>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                    
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script>
export default {
    data(){
        return{
            search:'',
            communityCode:'',
            dialog:false,
            dialog2:false,
            loading:false,
            snackbar:false,
            text:'',
            snackcolor:'',
            initials:'',
            headers: [
                {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'community_name',
                class:'font-weight-black'
                },
                {text: 'No Of Members', value:'no_of_members'},
                {text:'Community Code', value:'community_code'},
                { text: '', value: 'action', sortable: false },
            ],
        }
    },
    computed:{
        assessor(){
            return this.$store.state.lossassessors.lossAssessorById
        },
        Community(){
            return this.$store.state.lossassessors.lossAssessorById.communities
        },
        communities(){
            return this.$store.state.lossassessors.communities
        }
    },
    methods:{
        
        getName(id){
            this.$store.dispatch("CommunityById", id)
            .then((success)=>{
                console.log(success)
                this.$router.push('/community/members')
            })
            .catch((error)=>{
                console.log(error);
            })
        },
        assign(){
            this.loading=true
            this.$store.dispatch("AssignOrRemoveLossAssessor",{
                "type":"Assign",
                "lossAssessorId":this.$store.state.lossassessors.lossAssessorById.loss_assessor_id,
                "communityCode":this.communityCode
            })
            .then((success)=>{
                console.log(success)
                this.loading=false
                this.text="Community Assigned Successfully"
                this.snackcolor="green"
                this.snackbar=true
                this.$store.dispatch("getLossAssessorById", this.$store.state.lossassessors.lossAssessorById.loss_assessor_id)
                this.dialog=false
            })
            .catch((error)=>{
                this.loading=false
                this.text="Community not assigned"
                this.snackcolor="red"
                this.snackbar=true
                console.log(error)
            })
        }, 
        remove(){
            this.loading=true
            this.$store.dispatch("AssignOrRemoveLossAssessor",{
                "type":"Remove",
                "lossAssessorId":this.$store.state.lossassessors.lossAssessorById.loss_assessor_id,
                "communityCode":this.communityCode
            })
            .then((success)=>{
                console.log(success)
                this.loading=false
                this.text="Community Removed Successfully"
                this.snackcolor="green"
                this.snackbar=true
                this.$store.dispatch("getLossAssessorById", this.$store.state.lossassessors.lossAssessorById.loss_assessor_id)
                this.dialog=false
            })
            .catch((error)=>{
                this.loading=false
                this.text="Community not removed"
                this.snackcolor="red"
                this.snackbar=true
                console.log(error)
            })
        }  
    },
    created(){
        this.$store.dispatch("CommunityCodeName")
        .then((success)=>{
            console.log(success)
        })
        .catch((error)=>{
            console.log(error)
        })
        let namesArray = this.$store.state.lossassessors.lossAssessorById.name.split(' ');
        if (namesArray.length === 1) 
        this.initial= `${namesArray[0].charAt(0)}`;
        else 
        this.initials= `${namesArray[0].charAt(0)}.${namesArray[namesArray.length - 1].charAt(0)}`;
        
        
    }
}
</script>

<style scoped>

</style>